import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefive-contact',
  templateUrl: './homefive-contact.component.html',
  styleUrls: ['./homefive-contact.component.scss']
})
export class HomefiveContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
